// src/components/shared/StatCard.jsx
import React from 'react';
import '../../styles/Dashboard.css';

const StatCard = ({ icon, title, value, color = 'blue' }) => {
  const colorClasses = {
    blue: 'stat-card-blue',
    green: 'stat-card-green',
    orange: 'stat-card-orange',
    purple: 'stat-card-purple',
    red: 'stat-card-red',
  };

  return (
    <div className={`stat-card ${colorClasses[color] || colorClasses.blue}`}>
      <div className="stat-card-icon">{icon}</div>
      <div className="stat-card-content">
        <h3 className="stat-card-title">{title}</h3>
        <p className="stat-card-value">{value}</p>
      </div>
    </div>
  );
};

export default StatCard;